import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-[#0D1B2A] border border-[rgba(0,229,255,0.2)] rounded-xl p-3 shadow-xl">
      <p className="text-[#94A3B8] text-xs mb-2">{label}</p>
      {payload?.map((p) => (
        <p key={p?.name} className="text-xs font-mono" style={{ color: p?.color }}>
          {p?.name}: ${p?.value?.toLocaleString()}
        </p>
      ))}
    </div>
  );
};

export default function SpendingBarChart({ data }) {
  return (
    <div className="bg-[rgba(255,255,255,0.03)] border border-[rgba(0,229,255,0.1)] rounded-xl p-5">
      <h3 className="text-[#E2E8F0] font-semibold text-sm mb-4">Monthly Spending by Category</h3>
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" />
          <XAxis dataKey="category" tick={{ fill: '#64748B', fontSize: 11 }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fill: '#64748B', fontSize: 11 }} axisLine={false} tickLine={false} tickFormatter={(v) => `$${v}`} />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ fontSize: 12, color: '#94A3B8' }} />
          <Bar dataKey="lastMonth" name="Last Month" fill="#7B2FBE" radius={[4, 4, 0, 0]} opacity={0.7} />
          <Bar dataKey="thisMonth" name="This Month" fill="#00E5FF" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
